import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Ressources de traduction
const resources = {
  fr: {
    translation: {
      // Navigation & Global
      "language_selector": "Langue",
      "switch_to": "Passer en {{lang}}",
      "home_link_aria": "WebCaliskan Accueil",
      "logo_alt": "Logo WebCaliskan",
      "tagline": "Décrivez. Nous construisons.",
      "scroll_to_top": "Retour en haut",
      
      // Hero section
      "hero_title": "Parlez-nous de votre projet",
      "hero_subtitle": "Complétez ce formulaire détaillé pour que nous puissions estimer, concevoir et lancer votre solution digitale sur mesure.",
      "completion_percent": "{{percent}}% complété",
      
      // Form sections
      "section_identification": "1. Identification",
      "section_project_type": "2. Type de projet",
      "section_features": "3. Fonctionnalités clés",
      "optional": "optionnel",
      "features_optional_hint": "Vous pouvez sélectionner des fonctionnalités courantes ici, ou simplement tout décrire dans le champ description ci-dessous.",
      "section_design": "4. Design & Inspiration",
  "section_details": "5. Détails supplémentaires",
  "section_hosting": "6. Hébergement du site",
      
      // Form fields
      "company_name": "Nom entreprise",
      "contact_name": "Nom contact", 
      "email": "Email",
      "phone": "Téléphone",
      "role": "Rôle",
      "current_url": "URL actuelle",
      "other_precision": "Autre précision",
      "add_feature": "Ajouter une fonctionnalité",
      "target_countries": "Pays ciblés",
      "inspiration_links": "Liens d'inspiration",
      "description": "Description détaillée",
  "hosting_lifetime_title": "Hébergement gratuit à vie",
  "hosting_lifetime_desc": "+100€ sur le devis avec gestion et maintenance incluses.",
  "hosting_monthly_title": "Abonnement hébergement 15€ / mois",
  "hosting_monthly_desc": "Serveur géré par nos soins, facturation mensuelle flexible.",
  "hosting_lifetime_badge": "+100€",
  "hosting_monthly_badge": "15€/mois",
  "hosting_confirm_message": "Est-ce que vous voulez vraiment passer à côté de l'hébergement gratuit à vie ?",
  "hosting_summary_title": "Hébergement",
  "hosting_summary_lifetime": "Pack hébergement gratuit à vie (+100€ sur le devis).",
  "hosting_summary_monthly": "Abonnement hébergement 15€ / mois (facturé séparément).",
      
      // Roles
      "role_founder": "Fondateur/Dirigeant",
      "role_marketing": "Marketing/Communication",
      "role_cto": "CTO/Technique",
      "role_other": "Autre",
      
      // Project types
      "website": "Site vitrine",
      "ecommerce": "Site e-commerce", 
      "web_app": "Application web",
      "mobile_app": "Application mobile",
      "saas": "SaaS",
      "marketplace": "Marketplace",
      "blog": "Blog / Magazine",
      "portfolio": "Portfolio",
      "corporate": "Site corporate",
      "other": "Autre",
      
      // Project types (mapped keys)
      "project_landing": "Landing page",
      "project_showcase": "Site vitrine",
      "project_ecommerce": "Site e-commerce",
      "project_webapp": "Application web",
      "project_mobile": "Application mobile",
      "project_redesign": "Refonte de site",
      "project_blog": "Blog / Magazine",
      "project_portfolio": "Portfolio",
      "project_autre": "Autre",
      
      // Objectives
      "increase_sales": "Augmenter les ventes",
      "improve_brand": "Améliorer la notoriété de marque",
      "optimize_process": "Optimiser un processus métier",
      "reach_new_market": "Atteindre un nouveau marché",
      "improve_ux": "Améliorer l'expérience utilisateur",
      "modernize": "Moderniser l'existant",
      "automate": "Automatiser des tâches",
      
      // Features
      "booking": "Système de réservation",
      "payment": "Paiement en ligne",
      "user_account": "Comptes utilisateurs",
      "admin_panel": "Panel d'administration",
      "inventory": "Gestion stock",
      "crm": "CRM intégré",
      "analytics": "Analytics avancées",
      "api": "API / Intégrations",
      "multilingual": "Multi-langues",
      "responsive": "Design responsive",
      "seo": "Optimisation SEO",
      "security": "Sécurité renforcée",
      
      // Audience
      "audience_b2b": "B2B (entreprises)",
      "audience_b2c": "B2C (particuliers)",
      "audience_internal": "Interne (employés)",
      "audience_mixed": "Mixte",
      "number_users": "Nombre d'utilisateurs",
      "users_50": "< 50",
      "users_50_200": "50-200",
      "users_200_1000": "200-1000",
      "users_1000": "1000+",
      
      // Content types
      "text_content": "Contenu texte",
      "images": "Images/Photos",
      "videos": "Vidéos",
      "documents": "Documents",
      "product_catalog": "Catalogue produits",
      "blog_content": "Contenu blog",
      "legal_pages": "Pages légales",
      
      // Budget ranges
      "budget_2k": "< 2k",
      "budget_2_5k": "2k-5k", 
      "budget_5_10k": "5k-10k",
      "budget_10_25k": "10k-25k",
      "budget_25_50k": "25k-50k",
      "budget_50k_plus": "50k+",
      "estimated_budget": "Budget estimé",
      "desired_deadline": "Délai souhaité",
      
      // Deadlines
      "deadline_asap": "ASAP",
      "deadline_1m": "< 1 mois",
      "deadline_1_2m": "1-2 mois", 
      "deadline_3m": "3 mois",
      "deadline_3m_plus": "> 3 mois",
      
      // Priorities
      "priority_deadline": "Respect des délais",
      "priority_quality": "Qualité maximale",
      "priority_cost": "Contrôle des coûts",
      "priority_scalability": "Évolutivité",
      "priority_ux": "Expérience utilisateur",
      
      // Design styles
      "style_minimalist": "Minimaliste",
      "style_corporate": "Corporate",
      "style_modern": "Moderne",
      "style_premium": "Premium",
      "style_fun": "Fun/Créatif",
      "style_technical": "Technique",
      "inspiration_urls": "URLs d'inspiration",
      "expected_style": "Style attendu",
      
      // Framework preferences
      "framework_react": "React",
      "framework_vue": "Vue.js",
      "framework_angular": "Angular",
      "framework_wordpress": "WordPress",
      "framework_shopify": "Shopify",
      "framework_custom": "Solution sur mesure",
      "framework_no_preference": "Pas de préférence",
      
      // Buttons & Actions
      "add_button": "Ajouter",
      "reset_button": "Réinitialiser",
      "submit_button": "Envoyer le formulaire",
      "sending": "Envoi en cours...",
      "autosave": "Sauvegarde...",
      
      // Messages
      "saved_at": "Sauvegardé à {{time}}",
      "submitting": "Envoi en cours...",
      "submit_success": "Formulaire envoyé avec succès !",
      "submit_error": "Erreur lors de l'envoi : {{error}}",
      "confirm_reset": "Effacer le formulaire ?",
      
      // Additional form options
      "option_other": "Autre",
      "option_none": "--",
      "current_url_label": "URL actuelle",
      "other_precision_label": "Autre précision",
      
      // Page volume options
      "pages_1_5": "1-5",
      "pages_5_15": "5-15",
      "pages_15_40": "15-40",
      "pages_40": "40+",
      "page_volume": "Volume de pages",
      
      // Content management options
      "cms_static": "Statique",
      "cms_simple": "CMS simple",
      "cms_custom": "Panel d'admin sur mesure",
      
      // Media options
      "media_images": "Images",
      "media_video": "Vidéo",
      "media_documents": "Documents",
      "media_none": "Aucun",
      
      // Summary section
      "dynamic_summary": "Résumé Dynamique",
      "completion_label": "Complété à {{percent}}%",
      "complexity_label": "Complexité",
      "complexity_basique": "Basique",
      "complexity_standard": "Standard", 
      "complexity_avancé": "Avancé",
      "complexity_complexe": "Complexe",
      "price_estimate": "Estimation tarifaire",
      "base_minimum": "Base minimum",
      "includes_label": "Inclut",
      "price_note": "Tarif indicatif régional – devis définitif après échange.",
      "identification_summary": "Identification",
      "type_summary": "Type",
      "objectives_summary": "Objectifs",
      "features_summary": "Fonctionnalités",
      "framework_summary": "Framework",
      "priorities_summary": "Priorités",
      "description_summary": "Description",
      "company_label": "Entreprise",
      "contact_label": "Contact",
      "phone_label": "Tél",
      "budget_label": "Budget",
      "deadline_label": "Délai",
      
      // Placeholders
      "add_feature_placeholder": "Ajouter une fonctionnalité",
      "other_objective_placeholder": "Autre objectif",
      "target_countries_placeholder": "France, Canada...",
      "inspiration_links_placeholder": "Liens d'inspiration (1 par ligne)",
      "description_placeholder": "Décrivez votre projet, vos besoins, fonctionnalités souhaitées, délais...",
      "description_help": "💡 Mentionnez les fonctionnalités importantes, vos objectifs, contraintes de temps, budget approximatif, ou toute autre information utile.",
      "https_placeholder": "https://...",
      
      // HowItWorks Component
      "how_title": "Comment ça marche ?",
      "how_subtitle": "Un processus clair en 5 étapes pour transformer votre idée en réalité",
      "how_step1_title": "Formulaire Détaillé",
      "how_step1_desc": "Vous remplissez le formulaire avec tous les détails de votre projet",
      "how_step1_duration": "10 min",
      "how_step2_title": "Devis Personnalisé",
      "how_step2_desc": "Nous analysons votre demande et vous envoyons un devis sur mesure sous 24h",
      "how_step2_duration": "24h",
      "how_step3_title": "Design & Maquettes",
      "how_step3_desc": "Notre équipe crée les maquettes visuelles pour validation",
      "how_step3_duration": "3-5 jours",
      "how_step4_title": "Développement",
      "how_step4_desc": "Nous développons votre solution avec des points de suivi réguliers",
      "how_step4_duration": "2-8 semaines",
      "how_step5_title": "Livraison & Lancement",
      "how_step5_desc": "Tests finaux, mise en ligne et formation à l'utilisation",
      "how_step5_duration": "2-3 jours",
      "how_cta_title": "Prêt à démarrer votre projet ?",
      "how_cta_primary": "Remplir le formulaire",
      "how_cta_secondary": "Nous appeler",
      
      // TrustBar Component
      "trust_secure_payment": "Paiement sécurisé",
      "trust_quick_quote": "Devis sous 24h",
      "trust_support": "Support 30 jours",
      "trust_delivery": "Livraison garantie",
      
      // FAQ Component
      "faq_title": "Questions Fréquentes",
      "faq_subtitle": "Tout ce que vous devez savoir avant de commencer",
      "faq_q1": "Combien coûte un site web ?",
      "faq_a1": "Le prix varie selon la complexité : 500-2000€ pour un site vitrine, 1000-6000€ pour un e-commerce, et plus pour des solutions sur mesure. Chaque projet est unique, c'est pourquoi nous établissons un devis personnalisé après analyse de votre demande.",
      "faq_q2": "Combien de temps prend la réalisation ?",
      "faq_a2": "Un site vitrine prend généralement 2-4 semaines, un e-commerce 4-8 semaines, et une application complexe 2-6 mois. Les délais dépendent de la complexité du projet et de la rapidité des validations.",
      "faq_q3": "Puis-je modifier mon site après la livraison ?",
      "faq_a3": "Absolument ! Nous livrons tous nos projets avec un panel d'administration intuitif qui vous permet de modifier facilement le contenu (textes, images, produits). Pour des modifications techniques, nous proposons des formules de maintenance.",
      "faq_q4": "Proposez-vous l'hébergement ?",
      "faq_a4": "Oui ! Nous proposons deux options : un pack hébergement gratuit à vie (+100€ sur le devis initial) ou un abonnement mensuel à 15€. Dans les deux cas, nous gérons l'infrastructure, la sécurité et les sauvegardes.",
      "faq_q5": "Mon site sera-t-il optimisé pour mobile ?",
      "faq_a5": "Tous nos sites sont 100% responsive, c'est-à-dire parfaitement adaptés aux smartphones, tablettes et ordinateurs. Nous testons sur tous les appareils avant la livraison.",
      "faq_q6": "Qu'est-ce qui est inclus dans le prix ?",
      "faq_a6": "Le prix comprend : design sur mesure, développement, intégration de vos contenus, optimisation SEO de base, formation à l'utilisation, 30 jours de support post-lancement. L'hébergement et le nom de domaine sont en supplément.",
      "faq_q7": "Puis-je avoir des exemples de vos réalisations ?",
      "faq_a7": "Bien sûr ! Contactez-nous par téléphone ou email et nous vous enverrons notre portfolio avec des projets similaires au vôtre. Chaque projet étant confidentiel, certains exemples ne peuvent être partagés publiquement.",
      "faq_q8": "Comment se passe le paiement ?",
      "faq_a8": "Nous fonctionnons généralement en 3 fois : 30% à la signature du devis, 40% à la validation des maquettes, et 30% à la livraison finale. D'autres arrangements sont possibles selon votre situation.",
      "faq_more_questions": "Vous avez d'autres questions ?",
      "faq_call_us": "Appelez-nous",
      "faq_send_brief": "Remplir le formulaire",
      
      // CTA Variations
      "cta_urgent_badge": "Offre limitée",
      "cta_urgent_title": "Lancez votre projet dès aujourd'hui !",
      "cta_urgent_subtitle": "Profitez de notre offre spéciale pour les 5 prochains clients",
      "cta_urgent_benefit1": "Devis gratuit sous 24h",
      "cta_urgent_benefit2": "-15% sur le développement",
      "cta_urgent_benefit3": "Support prioritaire",
      "cta_urgent_button": "J'en profite maintenant",
      "cta_urgent_remaining": "Plus que 2 places disponibles ce mois-ci",
      
      "cta_trust_title": "Travaillez avec une agence de confiance",
      "cta_trust_subtitle": "Plus de 50 clients satisfaits nous font confiance pour leurs projets digitaux",
      "cta_trust_guarantee1_title": "Garantie satisfaction",
      "cta_trust_guarantee1_desc": "Révisions illimitées jusqu'à validation finale",
      "cta_trust_guarantee2_title": "Paiement sécurisé",
      "cta_trust_guarantee2_desc": "Transactions protégées et fractionnées",
      "cta_trust_guarantee3_title": "Livraison dans les délais",
      "cta_trust_guarantee3_desc": "Ou remboursement intégral",
      "cta_trust_card_title": "Rejoignez nos clients satisfaits",
      "cta_trust_reviews": "23 avis",
      "cta_trust_button": "Démarrer mon projet",
      "cta_trust_note": "Sans engagement • Devis gratuit",
      
      "cta_comparison_title": "Avant / Après WebCaliskan",
      "cta_comparison_subtitle": "Voyez la différence que nous pouvons faire pour votre entreprise",
      "cta_comparison_before_title": "Sans site professionnel",
      "cta_comparison_before1": "Crédibilité limitée auprès des clients",
      "cta_comparison_before2": "Dépendance aux réseaux sociaux",
      "cta_comparison_before3": "Difficulté à présenter vos services",
      "cta_comparison_before4": "Perte d'opportunités commerciales",
      "cta_comparison_after_title": "Avec WebCaliskan",
      "cta_comparison_after1": "Image professionnelle et moderne",
      "cta_comparison_after2": "Visibilité 24/7 sur Google",
      "cta_comparison_after3": "Présentation claire de votre offre",
      "cta_comparison_after4": "Génération de leads qualifiés",
      "cta_comparison_button": "Faire la différence maintenant",
      
      "cta_simple_title": "Une question ? Un projet ?",
      "cta_simple_subtitle": "Discutons de votre idée autour d'un café (virtuel) ☕",
      "cta_simple_button1": "Remplir le formulaire",
      "cta_simple_button2": "📞 06 49 87 62 36",
      
      // Theme Toggle
      "theme_toggle_aria": "Changer le thème",
      "theme_switch_to_dark": "Passer en mode sombre",
      "theme_switch_to_light": "Passer en mode clair",
      
      // Availability Widget
      "locale_code": "fr-FR",
      "availability_available": "Disponible maintenant",
      "availability_available_message": "Notre équipe est en ligne et prête à répondre",
      "availability_busy": "Temporairement occupé",
      "availability_busy_message": "Nous revenons vers vous dans quelques minutes",
      "availability_offline": "Actuellement hors ligne",
      "availability_offline_message": "Nous répondrons dès notre retour",
      "availability_next_slots": "Prochains créneaux disponibles",
      "availability_call_now": "Appeler maintenant",
      "availability_send_brief": "Remplir le formulaire",
      "availability_response_time": "Réponse garantie sous 24h",
      
      // Hero Section
      "hero_rating": "4.9/5 - 23 avis clients",
      "hero_clients": "+50 projets réalisés",
      "hero_main_title": "Transformez votre idée en ",
      "hero_title_highlight": "site professionnel",
      "hero_description": "Agence web spécialisée en création de sites vitrine, e-commerce et applications sur mesure. Devis personnalisé sous 24h, livraison garantie.",
      "hero_feature1": "Devis sous 24h",
      "hero_feature2": "À partir de 500€",
      "hero_feature3": "Livraison garantie",
      "hero_cta_primary": "Démarrer mon projet",
      "hero_cta_secondary": "06 49 87 62 36",
      "hero_trust1": "Réponse rapide",
      "hero_trust2": "Clients satisfaits",
      "hero_trust3": "Note moyenne",
      "hero_scroll": "Découvrir nos services",
      
      // Services Section
      "services_title": "Nos Services",
      "services_subtitle": "Des solutions web adaptées à tous vos besoins",
      "service1_title": "Site Vitrine",
      "service1_desc": "Site professionnel pour présenter votre entreprise et vos services",
      "service1_feature1": "Design sur mesure",
      "service1_feature2": "Optimisation SEO",
      "service1_feature3": "Responsive mobile",
      "service1_feature4": "Hébergement inclus",
      "service1_price": "À partir de 500€",
      "service2_title": "E-commerce",
      "service2_desc": "Boutique en ligne complète pour vendre vos produits 24/7",
      "service2_feature1": "Paiement sécurisé",
      "service2_feature2": "Gestion catalogue",
      "service2_feature3": "Suivi commandes",
      "service2_feature4": "Analytics intégrées",
      "service2_price": "À partir de 3000€",
      "service_popular": "Populaire",
      "service3_title": "Application Web",
      "service3_desc": "Solution sur mesure pour automatiser vos processus métier",
      "service3_feature1": "Architecture scalable",
      "service3_feature2": "API personnalisée",
      "service3_feature3": "Panel d'admin",
      "service3_feature4": "Support technique",
      "service3_price": "Sur devis",
      "service_cta": "Demander un devis",
      "services_footer_text": "Un projet spécifique en tête ?",
      "services_footer_cta": "Discutons-en"
    }
  },
  en: {
    translation: {
      // Navigation & Global
      "language_selector": "Language",
      "switch_to": "Switch to {{lang}}",
      "home_link_aria": "WebCaliskan Home",
      "logo_alt": "WebCaliskan Logo",
      "tagline": "Describe. We build.",
      "scroll_to_top": "Scroll to top",
      
      // Hero section
      "hero_title": "Tell us about your project",
      "hero_subtitle": "Complete this detailed form so we can estimate, design and launch your custom digital solution.",
      "completion_percent": "{{percent}}% completed",
      
      // Form sections
      "section_identification": "1. Identification",
      "section_project_type": "2. Project Type",
      "section_features": "3. Key Features",
      "optional": "optional",
      "features_optional_hint": "You can select common features here, or simply describe everything in the description field below.",
      "section_design": "4. Design & Inspiration",
  "section_details": "5. Additional Details",
  "section_hosting": "6. Website Hosting",
      
      // Form fields
      "company_name": "Company name",
      "contact_name": "Contact name",
      "email": "Email",
      "phone": "Phone",
      "role": "Role",
      "current_url": "Current URL",
      "other_precision": "Other specification",
      "add_feature": "Add a feature",
      "target_countries": "Target countries",
      "inspiration_links": "Inspiration links",
      "description": "Detailed description",
  "hosting_lifetime_title": "Lifetime hosting included",
  "hosting_lifetime_desc": "+€100 on the quote with hosting and maintenance handled for you.",
  "hosting_monthly_title": "Hosting subscription €15 / month",
  "hosting_monthly_desc": "Managed server with monthly billing and ongoing support.",
  "hosting_lifetime_badge": "+€100",
  "hosting_monthly_badge": "€15/month",
  "hosting_confirm_message": "Are you sure you want to miss out on lifetime free hosting?",
  "hosting_summary_title": "Hosting",
  "hosting_summary_lifetime": "Lifetime hosting pack (+€100 on the quote).",
  "hosting_summary_monthly": "Hosting subscription €15 / month (billed separately).",
      
      // Roles
      "role_founder": "Founder/CEO",
      "role_marketing": "Marketing/Communication",
      "role_cto": "CTO/Technical",
      "role_other": "Other",
      
      // Project types
      "website": "Showcase website",
      "ecommerce": "E-commerce site",
      "web_app": "Web application",
      "mobile_app": "Mobile app",
      "saas": "SaaS",
      "marketplace": "Marketplace",
      "blog": "Blog / Magazine",
      "portfolio": "Portfolio",
      "corporate": "Corporate site",
      "other": "Other",
      
      // Project types (mapped keys)
      "project_landing": "Landing page",
      "project_showcase": "Showcase website",
      "project_ecommerce": "E-commerce site",
      "project_webapp": "Web application",
      "project_mobile": "Mobile app",
      "project_redesign": "Website redesign",
      "project_blog": "Blog / Magazine",
      "project_portfolio": "Portfolio",
      "project_autre": "Other",
      
      // Objectives
      "increase_sales": "Increase sales",
      "improve_brand": "Improve brand awareness",
      "optimize_process": "Optimize business process",
      "reach_new_market": "Reach new market",
      "improve_ux": "Improve user experience",
      "modernize": "Modernize existing",
      "automate": "Automate tasks",
      
      // Features
      "booking": "Booking system",
      "payment": "Online payment",
      "user_account": "User accounts",
      "admin_panel": "Admin panel",
      "inventory": "Inventory management",
      "crm": "Integrated CRM",
      "analytics": "Advanced analytics",
      "api": "API / Integrations",
      "multilingual": "Multi-language",
      "responsive": "Responsive design",
      "seo": "SEO optimization",
      "security": "Enhanced security",
      
      // Audience
      "audience_b2b": "B2B (businesses)",
      "audience_b2c": "B2C (consumers)",
      "audience_internal": "Internal (employees)",
      "audience_mixed": "Mixed",
      "number_users": "Number of users",
      "users_50": "< 50",
      "users_50_200": "50-200",
      "users_200_1000": "200-1000",
      "users_1000": "1000+",
      
      // Content types
      "text_content": "Text content",
      "images": "Images/Photos",
      "videos": "Videos",
      "documents": "Documents",
      "product_catalog": "Product catalog",
      "blog_content": "Blog content",
      "legal_pages": "Legal pages",
      
      // Budget ranges
      "budget_2k": "< 2k",
      "budget_2_5k": "2k-5k",
      "budget_5_10k": "5k-10k", 
      "budget_10_25k": "10k-25k",
      "budget_25_50k": "25k-50k",
      "budget_50k_plus": "50k+",
      "estimated_budget": "Estimated budget",
      "desired_deadline": "Desired deadline",
      
      // Deadlines
      "deadline_asap": "ASAP",
      "deadline_1m": "< 1 month",
      "deadline_1_2m": "1-2 months",
      "deadline_3m": "3 months",
      "deadline_3m_plus": "> 3 months",
      
      // Priorities
      "priority_deadline": "Timeline",
      "priority_quality": "Quality",
      "priority_cost": "Cost",
      "priority_scalability": "Scalability", 
      "priority_ux": "User experience",
      
      // Design styles
      "style_minimalist": "Minimalist",
      "style_corporate": "Corporate",
      "style_modern": "Modern",
      "style_premium": "Premium",
      "style_fun": "Fun/Creative",
      "style_technical": "Technical",
      "inspiration_urls": "Inspiration URLs",
      "expected_style": "Expected style",
      
      // Framework preferences
      "framework_react": "React",
      "framework_vue": "Vue.js",
      "framework_angular": "Angular",
      "framework_wordpress": "WordPress",
      "framework_shopify": "Shopify",
      "framework_custom": "Custom solution",
      "framework_no_preference": "No preference",
      
      // Buttons & Actions
      "add_button": "Add",
      "reset_button": "Reset",
      "submit_button": "Submit form",
      "sending": "Sending...",
      "autosave": "Saving...",
      
      // Messages
      "saved_at": "Saved at {{time}}",
      "submitting": "Submitting...",
      "submit_success": "Form submitted successfully!",
      "submit_error": "Submission error: {{error}}",
      "confirm_reset": "Clear form?",
      
      // Additional form options
      "option_other": "Other",
      "option_none": "--",
      "current_url_label": "Current URL",
      "other_precision_label": "Other specification",
      
      // Page volume options
      "pages_1_5": "1-5",
      "pages_5_15": "5-15",
      "pages_15_40": "15-40",
      "pages_40": "40+",
      "page_volume": "Page volume",
      
      // Content management options
      "cms_static": "Static",
      "cms_simple": "Simple CMS",
      "cms_custom": "Custom admin panel",      // Media options
      "media_images": "Images",
      "media_video": "Video",
      "media_documents": "Documents",
      "media_none": "None",
      
      // Summary section
      "dynamic_summary": "Dynamic Summary",
      "completion_label": "{{percent}}% Completed",
      "complexity_label": "Complexity",
      "complexity_basique": "Basic",
      "complexity_standard": "Standard",
      "complexity_avancé": "Advanced", 
      "complexity_complexe": "Complex",
      "price_estimate": "Price estimate",
      "base_minimum": "Minimum base",
      "includes_label": "Includes",
      "price_note": "Regional indicative price (Northern France) – final quote after discussion.",
      "identification_summary": "Identification",
      "type_summary": "Type",
      "objectives_summary": "Objectives",
      "features_summary": "Features",
      "framework_summary": "Framework",
      "priorities_summary": "Priorities",
      "description_summary": "Description",
      "company_label": "Company",
      "contact_label": "Contact",
      "phone_label": "Tel",
      "budget_label": "Budget",
      "deadline_label": "Deadline",
      
      // Placeholders
      "add_feature_placeholder": "Add feature",
      "other_objective_placeholder": "Other objective",
      "target_countries_placeholder": "France, Canada...",
      "inspiration_links_placeholder": "Inspiration links (1 per line)",
      "description_placeholder": "Describe your project, needs, desired features, deadlines...",
      "description_help": "💡 Mention important features, your goals, time constraints, approximate budget, or any other useful information.",
      "https_placeholder": "https://...",
      
      // HowItWorks Component
      "how_title": "How it works?",
      "how_subtitle": "A clear 5-step process to turn your idea into reality",
      "how_step1_title": "Detailed Form",
      "how_step1_desc": "You fill out the form with all your project details",
      "how_step1_duration": "10 min",
      "how_step2_title": "Custom Quote",
      "how_step2_desc": "We analyze your request and send you a tailored quote within 24h",
      "how_step2_duration": "24h",
      "how_step3_title": "Design & Mockups",
      "how_step3_desc": "Our team creates visual mockups for validation",
      "how_step3_duration": "3-5 days",
      "how_step4_title": "Development",
      "how_step4_desc": "We develop your solution with regular check-ins",
      "how_step4_duration": "2-8 weeks",
      "how_step5_title": "Delivery & Launch",
      "how_step5_desc": "Final testing, go-live and usage training",
      "how_step5_duration": "2-3 days",
      "how_cta_title": "Ready to start your project?",
      "how_cta_primary": "Fill the form",
      "how_cta_secondary": "Call us",
      
      // TrustBar Component
      "trust_secure_payment": "Secure payment",
      "trust_quick_quote": "Quote in 24h",
      "trust_support": "30-day support",
      "trust_delivery": "Guaranteed delivery",
      
      // FAQ Component
      "faq_title": "Frequently Asked Questions",
      "faq_subtitle": "Everything you need to know before starting",
      "faq_q1": "How much does a website cost?",
      "faq_a1": "Price varies by complexity: €500-2000 for a showcase site, €1000-6000 for e-commerce, and more for custom solutions. Each project is unique, which is why we provide a personalized quote after analyzing your request.",
      "faq_q2": "How long does development take?",
      "faq_a2": "A showcase site typically takes 2-4 weeks, an e-commerce site 4-8 weeks, and a complex application 2-6 months. Timelines depend on project complexity and validation speed.",
      "faq_q3": "Can I modify my site after delivery?",
      "faq_a3": "Absolutely! We deliver all projects with an intuitive admin panel that lets you easily modify content (text, images, products). For technical changes, we offer maintenance packages.",
      "faq_q4": "Do you provide hosting?",
      "faq_a4": "Yes! We offer two options: a lifetime free hosting pack (+€100 on initial quote) or a monthly subscription at €15. In both cases, we manage infrastructure, security and backups.",
      "faq_q5": "Will my site be mobile-optimized?",
      "faq_a5": "All our sites are 100% responsive, meaning perfectly adapted to smartphones, tablets and computers. We test on all devices before delivery.",
      "faq_q6": "What's included in the price?",
      "faq_a6": "The price includes: custom design, development, content integration, basic SEO optimization, usage training, 30 days post-launch support. Hosting and domain name are extra.",
      "faq_q7": "Can I see examples of your work?",
      "faq_a7": "Of course! Contact us by phone or email and we'll send you our portfolio with projects similar to yours. Since each project is confidential, some examples can't be shared publicly.",
      "faq_q8": "How does payment work?",
      "faq_a8": "We typically work in 3 installments: 30% upon quote signature, 40% upon mockup validation, and 30% upon final delivery. Other arrangements are possible based on your situation.",
      "faq_more_questions": "Have more questions?",
      "faq_call_us": "Call us",
      "faq_send_brief": "Fill the form",
      
      // CTA Variations
      "cta_urgent_badge": "Limited offer",
      "cta_urgent_title": "Launch your project today!",
      "cta_urgent_subtitle": "Take advantage of our special offer for the next 5 clients",
      "cta_urgent_benefit1": "Free quote within 24h",
      "cta_urgent_benefit2": "-15% on development",
      "cta_urgent_benefit3": "Priority support",
      "cta_urgent_button": "Take advantage now",
      "cta_urgent_remaining": "Only 2 spots left this month",
      
      "cta_trust_title": "Work with a trusted agency",
      "cta_trust_subtitle": "Over 50 satisfied clients trust us with their digital projects",
      "cta_trust_guarantee1_title": "Satisfaction guarantee",
      "cta_trust_guarantee1_desc": "Unlimited revisions until final validation",
      "cta_trust_guarantee2_title": "Secure payment",
      "cta_trust_guarantee2_desc": "Protected and split transactions",
      "cta_trust_guarantee3_title": "On-time delivery",
      "cta_trust_guarantee3_desc": "Or full refund",
      "cta_trust_card_title": "Join our satisfied clients",
      "cta_trust_reviews": "23 reviews",
      "cta_trust_button": "Start my project",
      "cta_trust_note": "No commitment • Free quote",
      
      "cta_comparison_title": "Before / After WebCaliskan",
      "cta_comparison_subtitle": "See the difference we can make for your business",
      "cta_comparison_before_title": "Without professional site",
      "cta_comparison_before1": "Limited credibility with clients",
      "cta_comparison_before2": "Dependent on social media",
      "cta_comparison_before3": "Difficulty presenting your services",
      "cta_comparison_before4": "Lost business opportunities",
      "cta_comparison_after_title": "With WebCaliskan",
      "cta_comparison_after1": "Professional and modern image",
      "cta_comparison_after2": "24/7 visibility on Google",
      "cta_comparison_after3": "Clear presentation of your offer",
      "cta_comparison_after4": "Qualified lead generation",
      "cta_comparison_button": "Make the difference now",
      
      "cta_simple_title": "A question? A project?",
      "cta_simple_subtitle": "Let's discuss your idea over a (virtual) coffee ☕",
      "cta_simple_button1": "Fill the form",
      "cta_simple_button2": "📞 +33 6 49 87 62 36",
      
      // Theme Toggle
      "theme_toggle_aria": "Toggle theme",
      "theme_switch_to_dark": "Switch to dark mode",
      "theme_switch_to_light": "Switch to light mode",
      
      // Availability Widget
      "locale_code": "en-US",
      "availability_available": "Available now",
      "availability_available_message": "Our team is online and ready to respond",
      "availability_busy": "Temporarily busy",
      "availability_busy_message": "We'll get back to you in a few minutes",
      "availability_offline": "Currently offline",
      "availability_offline_message": "We'll respond as soon as we return",
      "availability_next_slots": "Next available slots",
      "availability_call_now": "Call now",
      "availability_send_brief": "Fill the form",
      "availability_response_time": "Response guaranteed within 24h",
      
      // Hero Section
      "hero_rating": "4.9/5 - 23 client reviews",
      "hero_clients": "+50 completed projects",
      "hero_main_title": "Transform your idea into a ",
      "hero_title_highlight": "professional website",
      "hero_description": "Web agency specialized in showcase sites, e-commerce and custom applications. Personalized quote within 24h, guaranteed delivery.",
      "hero_feature1": "Quote in 24h",
      "hero_feature2": "From €500",
      "hero_feature3": "Guaranteed delivery",
      "hero_cta_primary": "Start my project",
      "hero_cta_secondary": "+33 6 49 87 62 36",
      "hero_trust1": "Fast response",
      "hero_trust2": "Satisfied clients",
      "hero_trust3": "Average rating",
      "hero_scroll": "Discover our services",
      
      // Services Section
      "services_title": "Our Services",
      "services_subtitle": "Web solutions adapted to all your needs",
      "service1_title": "Showcase Website",
      "service1_desc": "Professional site to present your company and services",
      "service1_feature1": "Custom design",
      "service1_feature2": "SEO optimization",
      "service1_feature3": "Mobile responsive",
      "service1_feature4": "Hosting included",
      "service1_price": "From €500",
      "service2_title": "E-commerce",
      "service2_desc": "Complete online store to sell your products 24/7",
      "service2_feature1": "Secure payment",
      "service2_feature2": "Catalog management",
      "service2_feature3": "Order tracking",
      "service2_feature4": "Built-in analytics",
      "service2_price": "From €3000",
      "service_popular": "Popular",
      "service3_title": "Web Application",
      "service3_desc": "Custom solution to automate your business processes",
      "service3_feature1": "Scalable architecture",
      "service3_feature2": "Custom API",
      "service3_feature3": "Admin panel",
      "service3_feature4": "Technical support",
      "service3_price": "On quote",
      "service_cta": "Request a quote",
      "services_footer_text": "Have a specific project in mind?",
      "services_footer_cta": "Let's discuss"
    }
  },
  tr: {
    translation: {
      // Navigation & Global
      "language_selector": "Dil",
      "switch_to": "{{lang}} diline geç",
      "home_link_aria": "WebCaliskan Ana Sayfa",
      "logo_alt": "WebCaliskan Logosu",
      "tagline": "Açıklayın. Biz inşa ederiz.",
      "scroll_to_top": "Başa dön",
      
      // Hero section
      "hero_title": "Projenizden bahsedin",
      "hero_subtitle": "Özel dijital çözümünüzü tahmin edebilmemiz, tasarlayabilmemiz ve başlatabilvmemiz için bu detaylı formu tamamlayın.",
      "completion_percent": "{{percent}}% tamamlandı",
      
      // Form sections
      "section_identification": "1. Kimlik",
      "section_project_type": "2. Proje Türü",
      "section_features": "3. Ana Özellikler",
      "optional": "isteğe bağlı",
      "features_optional_hint": "Burada yaygın özellikleri seçebilir veya aşağıdaki açıklama alanında her şeyi basitçe açıklayabilirsiniz.",
      "section_design": "4. Tasarım & İlham",
  "section_details": "5. Ek Detaylar",
  "section_hosting": "6. Site Barındırma",
      
      // Form fields
      "company_name": "Şirket adı",
      "contact_name": "İletişim adı",
      "email": "Email",
      "phone": "Telefon",
      "role": "Rol",
      "current_url": "Mevcut URL",
      "other_precision": "Diğer açıklama",
      "add_feature": "Özellik ekle",
      "target_countries": "Hedef ülkeler",
      "inspiration_links": "İlham linkleri",
      "description": "Detaylı açıklama",
  "hosting_lifetime_title": "Ömür boyu ücretsiz barındırma",
  "hosting_lifetime_desc": "Tek seferlik +100€ teklifinize eklenir, barındırma ve bakım bizden.",
  "hosting_monthly_title": "Aylık barındırma aboneliği 15€",
  "hosting_monthly_desc": "Yönetilen sunucu, aylık faturalama ve sürekli destek.",
  "hosting_lifetime_badge": "+100€",
  "hosting_monthly_badge": "15€/ay",
  "hosting_confirm_message": "Ömür boyu ücretsiz barındırma fırsatını gerçekten kaçırmak istiyor musunuz?",
  "hosting_summary_title": "Barındırma",
  "hosting_summary_lifetime": "Ömür boyu barındırma paketi (teklif üzerine +100€).",
  "hosting_summary_monthly": "Barındırma aboneliği 15€/ay (ayrıca faturalandırılır).",
      
      // Roles
      "role_founder": "Kurucu/CEO",
      "role_marketing": "Pazarlama/İletişim",
      "role_cto": "CTO/Teknik",
      "role_other": "Diğer",
      
      // Project types
      "website": "Tanıtım sitesi",
      "ecommerce": "E-ticaret sitesi",
      "web_app": "Web uygulaması",
      "mobile_app": "Mobil uygulama",
      "saas": "SaaS",
      "marketplace": "Marketplace",
      "blog": "Blog / Dergi",
      "portfolio": "Portfoy",
      "corporate": "Kurumsal site",
      "other": "Diğer",
      
      // Project types (mapped keys)
      "project_landing": "Landing page",
      "project_showcase": "Tanıtım sitesi",
      "project_ecommerce": "E-ticaret sitesi",
      "project_webapp": "Web uygulaması",
      "project_mobile": "Mobil uygulama",
      "project_redesign": "Site yenileme",
      "project_blog": "Blog / Dergi",
      "project_portfolio": "Portfoy",
      "project_autre": "Diğer",
      
      // Objectives
      "increase_sales": "Satışları artır",
      "improve_brand": "Marka bilinirliğini artır",
      "optimize_process": "İş sürecini optimize et",
      "reach_new_market": "Yeni pazara ulaş",
      "improve_ux": "Kullanıcı deneyimini iyileştir",
      "modernize": "Mevcut olanı modernleştir",
      "automate": "Görevleri otomatikleştir",
      
      // Features
      "booking": "Rezervasyon sistemi",
      "payment": "Online ödeme",
      "user_account": "Kullanıcı hesapları",
      "admin_panel": "Yönetici paneli",
      "inventory": "Stok yönetimi",
      "crm": "Entegre CRM",
      "analytics": "Gelişmiş analitik",
      "api": "API / Entegrasyonlar",
      "multilingual": "Çok dilli",
      "responsive": "Responsive tasarım",
      "seo": "SEO optimizasyonu",
      "security": "Güçlendirilmiş güvenlik",
      
      // Audience
      "audience_b2b": "B2B (işletmeler)",
      "audience_b2c": "B2C (tüketiciler)",
      "audience_internal": "İç (çalışanlar)",
      "audience_mixed": "Karışık",
      "number_users": "Kullanıcı sayısı",
      "users_50": "< 50",
      "users_50_200": "50-200",
      "users_200_1000": "200-1000",
      "users_1000": "1000+",
      
      // Content types
      "text_content": "Metin içeriği",
      "images": "Görseller/Fotoğraflar",
      "videos": "Videolar",
      "documents": "Dökümanlar",
      "product_catalog": "Ürün kataloğu",
      "blog_content": "Blog içeriği",
      "legal_pages": "Hukuki sayfalar",
      
      // Budget ranges
      "budget_2k": "< 2k",
      "budget_2_5k": "2k-5k",
      "budget_5_10k": "5k-10k",
      "budget_10_25k": "10k-25k",
      "budget_25_50k": "25k-50k",
      "budget_50k_plus": "50k+",
      "estimated_budget": "Tahmini bütçe",
      "desired_deadline": "İstenilen süre",
      
      // Deadlines
      "deadline_asap": "ASAP",
      "deadline_1m": "< 1 ay",
      "deadline_1_2m": "1-2 ay",
      "deadline_3m": "3 ay",
      "deadline_3m_plus": "> 3 ay",
      
      // Priorities
      "priority_deadline": "Süre",
      "priority_quality": "Kalite",
      "priority_cost": "Maliyet",
      "priority_scalability": "Ölçeklenebilirlik",
      "priority_ux": "Kullanıcı deneyimi",
      
      // Design styles
      "style_minimalist": "Minimalist",
      "style_corporate": "Kurumsal",
      "style_modern": "Modern",
      "style_premium": "Premium",
      "style_fun": "Eğlenceli/Yaratıcı",
      "style_technical": "Teknik",
      "inspiration_urls": "İlham URL'leri",
      "expected_style": "Beklenen stil",
      
      // Framework preferences
      "framework_react": "React",
      "framework_vue": "Vue.js",
      "framework_angular": "Angular",
      "framework_wordpress": "WordPress",
      "framework_shopify": "Shopify",
      "framework_custom": "Özel çözüm",
      "framework_no_preference": "Tercih yok",
      
      // Buttons & Actions
      "add_button": "Ekle",
      "reset_button": "Sıfırla",
      "submit_button": "Formu gönder",
      "sending": "Gönderiliyor...",
      "autosave": "Kaydediliyor...",
      
      // Messages
      "saved_at": "{{time}} kaydedildi",
      "submitting": "Gönderiliyor...",
      "submit_success": "Form başarıyla gönderildi!",
      "submit_error": "Gönderim hatası: {{error}}",
      "confirm_reset": "Formu temizle?",
      
      // Additional form options
      "option_other": "Diğer",
      "option_none": "--",
      "current_url_label": "Mevcut URL",
      "other_precision_label": "Diğer açıklama",
      
      // Page volume options
      "pages_1_5": "1-5",
      "pages_5_15": "5-15",
      "pages_15_40": "15-40",
      "pages_40": "40+",
      "page_volume": "Sayfa hacmi",
      
      // Content management options
      "cms_static": "Statik",
      "cms_simple": "CMS",
      "cms_custom": "Özel yönetim paneli",
      
      // Media options
      "media_images": "Görseller",
      "media_video": "Video",
      "media_documents": "Dökümanlar",
      "media_none": "Hiçbiri",
      
      // Summary section
      "dynamic_summary": "Dinamik Özet",
      "completion_label": "{{percent}}% Tamamlandı",
      "complexity_label": "Karmaşıklık",
      "complexity_basique": "Basit",
      "complexity_standard": "Standart",
      "complexity_avancé": "Gelişmiş",
      "complexity_complexe": "Karmaşık", 
      "price_estimate": "Fiyat tahmini",
      "base_minimum": "Minimum taban",
      "includes_label": "Dahil",
      "price_note": "Bölgesel gösterge fiyat (Kuzey Fransa) – görüşme sonrası kesin teklif.",
      "identification_summary": "Kimlik",
      "type_summary": "Tür",
      "objectives_summary": "Hedefler",
      "features_summary": "Özellikler",
      "framework_summary": "Çerçeve",
      "priorities_summary": "Öncelikler",
      "description_summary": "Açıklama",
      "company_label": "Şirket",
      "contact_label": "İletişim",
      "phone_label": "Tel",
      "budget_label": "Bütçe",
      "deadline_label": "Süre",
      
      // Placeholders
      "add_feature_placeholder": "Özellik ekle",
      "other_objective_placeholder": "Diğer hedef",
      "target_countries_placeholder": "Fransa, Kanada...",
      "inspiration_links_placeholder": "İlham linkleri (satır başına 1)",
      "description_placeholder": "Projenizi, ihtiyaçlarınızı, istenen özellikleri, son tarihleri açıklayın...",
      "description_help": "💡 Önemli özellikleri, hedeflerinizi, zaman kısıtlamalarını, yaklaşık bütçenizi veya faydalı diğer bilgileri belirtin.",
      "https_placeholder": "https://...",
      
      // HowItWorks Component
      "how_title": "Nasıl çalışır?",
      "how_subtitle": "Fikrinizi gerçeğe dönüştürmek için 5 adımlı net bir süreç",
      "how_step1_title": "Detaylı Form",
      "how_step1_desc": "Proje detaylarınızla formu doldurursunuz",
      "how_step1_duration": "10 dk",
      "how_step2_title": "Özel Teklif",
      "how_step2_desc": "Talebinizi analiz eder ve 24 saat içinde özel teklif gönderir",
      "how_step2_duration": "24s",
      "how_step3_title": "Tasarım & Maketler",
      "how_step3_desc": "Ekibimiz onay için görsel maketler oluşturur",
      "how_step3_duration": "3-5 gün",
      "how_step4_title": "Geliştirme",
      "how_step4_desc": "Düzenli kontroller ile çözümünüzü geliştiririz",
      "how_step4_duration": "2-8 hafta",
      "how_step5_title": "Teslimat & Yayın",
      "how_step5_desc": "Son testler, yayına alma ve kullanım eğitimi",
      "how_step5_duration": "2-3 gün",
      "how_cta_title": "Projenizi başlatmaya hazır mısınız?",
      "how_cta_primary": "Formu doldurun",
      "how_cta_secondary": "Bizi arayın",
      
      // TrustBar Component
      "trust_secure_payment": "Güvenli ödeme",
      "trust_quick_quote": "24 saatte teklif",
      "trust_support": "30 gün destek",
      "trust_delivery": "Garantili teslimat",
      
      // FAQ Component
      "faq_title": "Sıkça Sorulan Sorular",
      "faq_subtitle": "Başlamadan önce bilmeniz gereken her şey",
      "faq_q1": "Bir web sitesi ne kadar tutar?",
      "faq_a1": "Fiyat karmaşıklığa göre değişir: tanıtım sitesi için 500-2000€, e-ticaret için 1000-6000€ ve özel çözümler için daha fazla. Her proje benzersizdir, bu yüzden brifinizi analiz ettikten sonra kişiselleştirilmiş teklif sunuyoruz.",
      "faq_q2": "Geliştirme ne kadar sürer?",
      "faq_a2": "Tanıtım sitesi genelde 2-4 hafta, e-ticaret sitesi 4-8 hafta ve karmaşık uygulama 2-6 ay sürer. Süreler proje karmaşıklığına ve onay hızına bağlıdır.",
      "faq_q3": "Teslimattan sonra sitemi değiştirebilir miyim?",
      "faq_a3": "Kesinlikle! Tüm projeleri içeriği (metin, resim, ürün) kolayca değiştirmenizi sağlayan sezgisel yönetim paneliyle teslim ediyoruz. Teknik değişiklikler için bakım paketleri sunuyoruz.",
      "faq_q4": "Barındırma hizmeti veriyor musunuz?",
      "faq_a4": "Evet! İki seçenek sunuyoruz: ömür boyu ücretsiz barındırma paketi (ilk teklif üzerine +100€) veya aylık 15€ abonelik. Her iki durumda da altyapı, güvenlik ve yedeklemeleri biz yönetiyoruz.",
      "faq_q5": "Sitem mobil için optimize mi olacak?",
      "faq_a5": "Tüm sitelerimiz %100 responsive, yani akıllı telefon, tablet ve bilgisayarlara mükemmel şekilde uyarlanmıştır. Teslimattan önce tüm cihazlarda test ediyoruz.",
      "faq_q6": "Fiyata neler dahil?",
      "faq_a6": "Fiyata şunlar dahil: özel tasarım, geliştirme, içerik entegrasyonu, temel SEO optimizasyonu, kullanım eğitimi, lansmandan sonra 30 gün destek. Barındırma ve alan adı ekstradir.",
      "faq_q7": "Çalışmalarınızdan örnekler görebilir miyim?",
      "faq_a7": "Tabii ki! Telefon veya email ile iletişime geçin, size benzer projelerle portföyümüzü gönderelim. Her proje gizli olduğundan, bazı örnekler kamuoyuyla paylaşılamaz.",
      "faq_q8": "Ödeme nasıl çalışır?",
      "faq_a8": "Genelde 3 taksitte çalışırız: teklif imzasında %30, maket onayında %40 ve son teslimatta %30. Durumunuza göre diğer düzenlemeler mümkündür.",
      "faq_more_questions": "Daha fazla sorunuz mu var?",
      "faq_call_us": "Bizi arayın",
      "faq_send_brief": "Formu doldurun",
      
      // CTA Variations
      "cta_urgent_badge": "Sınırlı teklif",
      "cta_urgent_title": "Projenizi bugün başlatın!",
      "cta_urgent_subtitle": "Sonraki 5 müşteri için özel teklifimizden yararlanın",
      "cta_urgent_benefit1": "24 saat içinde ücretsiz teklif",
      "cta_urgent_benefit2": "Geliştirmede %15 indirim",
      "cta_urgent_benefit3": "Öncelikli destek",
      "cta_urgent_button": "Şimdi yararlan",
      "cta_urgent_remaining": "Bu ay sadece 2 yer kaldı",
      
      "cta_trust_title": "Güvenilir bir ajansla çalışın",
      "cta_trust_subtitle": "50'den fazla memnun müşteri dijital projeleri için bize güveniyor",
      "cta_trust_guarantee1_title": "Memnuniyet garantisi",
      "cta_trust_guarantee1_desc": "Son onaya kadar sınırsız revizyon",
      "cta_trust_guarantee2_title": "Güvenli ödeme",
      "cta_trust_guarantee2_desc": "Korumalı ve bölünmüş işlemler",
      "cta_trust_guarantee3_title": "Zamanında teslimat",
      "cta_trust_guarantee3_desc": "Veya tam para iadesi",
      "cta_trust_card_title": "Memnun müşterilerimize katılın",
      "cta_trust_reviews": "23 yorum",
      "cta_trust_button": "Projemi başlat",
      "cta_trust_note": "Taahhüt yok • Ücretsiz teklif",
      
      "cta_comparison_title": "WebCaliskan Öncesi / Sonrası",
      "cta_comparison_subtitle": "İşiniz için yapabileceğimiz farkı görün",
      "cta_comparison_before_title": "Profesyonel site olmadan",
      "cta_comparison_before1": "Müşteriler nezdinde sınırlı güvenilirlik",
      "cta_comparison_before2": "Sosyal medyaya bağımlılık",
      "cta_comparison_before3": "Hizmetlerinizi sunma zorluğu",
      "cta_comparison_before4": "Kaybedilen iş fırsatları",
      "cta_comparison_after_title": "WebCaliskan ile",
      "cta_comparison_after1": "Profesyonel ve modern imaj",
      "cta_comparison_after2": "Google'da 7/24 görünürlük",
      "cta_comparison_after3": "Teklifinizin net sunumu",
      "cta_comparison_after4": "Nitelikli müşteri adayı oluşturma",
      "cta_comparison_button": "Şimdi farkı yarat",
      
      "cta_simple_title": "Bir soru mu var? Bir proje mi?",
      "cta_simple_subtitle": "Fikrinizi bir (sanal) kahve eşliğinde konuşalım ☕",
      "cta_simple_button1": "Formu doldurun",
      "cta_simple_button2": "📞 +33 6 49 87 62 36",
      
      // Theme Toggle
      "theme_toggle_aria": "Temayı değiştir",
      "theme_switch_to_dark": "Karanlık moda geç",
      "theme_switch_to_light": "Aydınlık moda geç",
      
      // Availability Widget
      "locale_code": "tr-TR",
      "availability_available": "Şu anda müsait",
      "availability_available_message": "Ekibimiz çevrimiçi ve yanıt vermeye hazır",
      "availability_busy": "Geçici olarak meşgul",
      "availability_busy_message": "Birkaç dakika içinde size döneceğiz",
      "availability_offline": "Şu anda çevrimdışı",
      "availability_offline_message": "Dönüş yaptığımızda yanıt vereceğiz",
      "availability_next_slots": "Sonraki müsait zamanlar",
      "availability_call_now": "Şimdi ara",
      "availability_send_brief": "Formu doldurun",
      "availability_response_time": "24 saat içinde garantili yanıt",
      
      // Hero Section
      "hero_rating": "4.9/5 - 23 müşteri yorumu",
      "hero_clients": "+50 tamamlanmış proje",
      "hero_main_title": "Fikrinizi ",
      "hero_title_highlight": "profesyonel bir siteye",
      "hero_description": "Tanıtım siteleri, e-ticaret ve özel uygulamalar konusunda uzman web ajansı. 24 saat içinde kişiselleştirilmiş teklif, garantili teslimat.",
      "hero_feature1": "24 saatte teklif",
      "hero_feature2": "500€'dan başlayan",
      "hero_feature3": "Garantili teslimat",
      "hero_cta_primary": "Projeme başla",
      "hero_cta_secondary": "+33 6 49 87 62 36",
      "hero_trust1": "Hızlı yanıt",
      "hero_trust2": "Memnun müşteriler",
      "hero_trust3": "Ortalama puan",
      "hero_scroll": "Hizmetlerimizi keşfedin",
      
      // Services Section
      "services_title": "Hizmetlerimiz",
      "services_subtitle": "Tüm ihtiyaçlarınıza uygun web çözümleri",
      "service1_title": "Tanıtım Sitesi",
      "service1_desc": "Şirketinizi ve hizmetlerinizi sunmak için profesyonel site",
      "service1_feature1": "Özel tasarım",
      "service1_feature2": "SEO optimizasyonu",
      "service1_feature3": "Mobil uyumlu",
      "service1_feature4": "Hosting dahil",
      "service1_price": "500€'dan başlayan",
      "service2_title": "E-ticaret",
      "service2_desc": "Ürünlerinizi 7/24 satmak için eksiksiz online mağaza",
      "service2_feature1": "Güvenli ödeme",
      "service2_feature2": "Katalog yönetimi",
      "service2_feature3": "Sipariş takibi",
      "service2_feature4": "Entegre analitik",
      "service2_price": "3000€'dan başlayan",
      "service_popular": "Popüler",
      "service3_title": "Web Uygulaması",
      "service3_desc": "İş süreçlerinizi otomatikleştirmek için özel çözüm",
      "service3_feature1": "Ölçeklenebilir mimari",
      "service3_feature2": "Özel API",
      "service3_feature3": "Yönetim paneli",
      "service3_feature4": "Teknik destek",
      "service3_price": "Teklif üzerine",
      "service_cta": "Teklif iste",
      "services_footer_text": "Aklınızda özel bir proje mi var?",
      "services_footer_cta": "Tartışalım"
    }
  },
  nl: {
    translation: {
      // Navigation & Global
      "language_selector": "Taal",
      "switch_to": "Wissel naar {{lang}}",
      "home_link_aria": "WebCaliskan Home",
      "logo_alt": "WebCaliskan Logo",
      "tagline": "Beschrijf. Wij bouwen.",
      "scroll_to_top": "Naar boven",
      
      // Hero section
      "hero_title": "Vertel ons over uw project",
      "hero_subtitle": "Vul dit gedetailleerde formulier in zodat we uw op maat gemaakte digitale oplossing kunnen inschatten, ontwerpen en lanceren.",
      "completion_percent": "{{percent}}% voltooid",
      
      // Form sections
      "section_identification": "1. Identificatie",
      "section_project_type": "2. Projecttype",
      "section_features": "3. Kernfuncties",
      "optional": "optioneel",
      "features_optional_hint": "U kunt hier veelvoorkomende functies selecteren of alles eenvoudig beschrijven in het onderstaande beschrijvingsveld.",
      "section_design": "4. Design & Inspiratie",
  "section_details": "5. Extra Details",
  "section_hosting": "6. Websitehosting",
      
      // Form fields
      "company_name": "Bedrijfsnaam",
      "contact_name": "Contactpersoon",
      "email": "Email",
      "phone": "Telefoon",
      "role": "Rol",
      "current_url": "Huidige URL",
      "other_precision": "Andere specificatie",
      "add_feature": "Functie toevoegen",
      "target_countries": "Doellanden",
      "inspiration_links": "Inspiratie links",
      "description": "Gedetailleerde beschrijving",
  "hosting_lifetime_title": "Levenslange hosting inbegrepen",
  "hosting_lifetime_desc": "+€100 op de offerte, hosting en onderhoud zijn voor altijd inbegrepen.",
  "hosting_monthly_title": "Hostingabonnement €15 / maand",
  "hosting_monthly_desc": "Beheerde server met maandelijkse facturatie en ondersteuning.",
  "hosting_lifetime_badge": "+€100",
  "hosting_monthly_badge": "€15/maand",
  "hosting_confirm_message": "Weet u zeker dat u levenslange gratis hosting wilt missen?",
  "hosting_summary_title": "Hosting",
  "hosting_summary_lifetime": "Levenslang hostingpakket (+€100 op de offerte).",
  "hosting_summary_monthly": "Hostingabonnement €15 / maand (apart gefactureerd).",
      
      // Roles
      "role_founder": "Oprichter/CEO",
      "role_marketing": "Marketing/Communicatie",
      "role_cto": "CTO/Technisch",
      "role_other": "Anders",
      
      // Project types
      "website": "Showcase website",
      "ecommerce": "E-commerce site",
      "web_app": "Webapplicatie",
      "mobile_app": "Mobiele app",
      "saas": "SaaS",
      "marketplace": "Marketplace",
      "blog": "Blog / Magazine",
      "portfolio": "Portfolio",
      "corporate": "Bedrijfssite",
      "other": "Anders",
      
      // Project types (mapped keys)
      "project_landing": "Landing page",
      "project_showcase": "Showcase website",
      "project_ecommerce": "E-commerce site",
      "project_webapp": "Webapplicatie",
      "project_mobile": "Mobiele app",
      "project_redesign": "Website herontwerp",
      "project_blog": "Blog / Magazine",
      "project_portfolio": "Portfolio",
      "project_autre": "Anders",
      
      // Objectives
      "increase_sales": "Verkopen verhogen",
      "improve_brand": "Merkbekendheid verbeteren",
      "optimize_process": "Bedrijfsproces optimaliseren",
      "reach_new_market": "Nieuwe markt bereiken",
      "improve_ux": "Gebruikerservaring verbeteren",
      "modernize": "Bestaande moderniseren",
      "automate": "Taken automatiseren",
      
      // Features
      "booking": "Boekingssysteem",
      "payment": "Online betaling",
      "user_account": "Gebruikersaccounts",
      "admin_panel": "Beheerpaneel",
      "inventory": "Voorraadbeheer",
      "crm": "Geïntegreerde CRM",
      "analytics": "Geavanceerde analytics",
      "api": "API / Integraties",
      "multilingual": "Meertalig",
      "responsive": "Responsive design",
      "seo": "SEO optimalisatie",
      "security": "Verhoogde beveiliging",
      
      // Audience
      "audience_b2b": "B2B (bedrijven)",
      "audience_b2c": "B2C (consumenten)",
      "audience_internal": "Intern (medewerkers)",
      "audience_mixed": "Gemengd",
      "number_users": "Aantal gebruikers",
      "users_50": "< 50",
      "users_50_200": "50-200",
      "users_200_1000": "200-1000",
      "users_1000": "1000+",
      
      // Content types
      "text_content": "Tekstinhoud",
      "images": "Afbeeldingen/Foto's",
      "videos": "Video's",
      "documents": "Documenten",
      "product_catalog": "Productcatalogus",
      "blog_content": "Blog inhoud",
      "legal_pages": "Juridische pagina's",
      
      // Budget ranges
      "budget_2k": "< 2k",
      "budget_2_5k": "2k-5k",
      "budget_5_10k": "5k-10k",
      "budget_10_25k": "10k-25k",
      "budget_25_50k": "25k-50k",
      "budget_50k_plus": "50k+",
      "estimated_budget": "Geschat budget",
      "desired_deadline": "Gewenste deadline",
      
      // Deadlines
      "deadline_asap": "ZSM",
      "deadline_1m": "< 1 maand",
      "deadline_1_2m": "1-2 maanden",
      "deadline_3m": "3 maanden",
      "deadline_3m_plus": "> 3 maanden",
      
      // Priorities
      "priority_deadline": "Deadline",
      "priority_quality": "Kwaliteit",
      "priority_cost": "Kosten",
      "priority_scalability": "Schaalbaarheid",
      "priority_ux": "Gebruikerservaring",
      
      // Design styles
      "style_minimalist": "Minimalistisch",
      "style_corporate": "Zakelijk",
      "style_modern": "Modern",
      "style_premium": "Premium",
      "style_fun": "Speels/Creatief",
      "style_technical": "Technisch",
      "inspiration_urls": "Inspiratie URL's",
      "expected_style": "Verwachte stijl",
      
      // Framework preferences
      "framework_react": "React",
      "framework_vue": "Vue.js",
      "framework_angular": "Angular",
      "framework_wordpress": "WordPress",
      "framework_shopify": "Shopify",
      "framework_custom": "Aangepaste oplossing",
      "framework_no_preference": "Geen voorkeur",
      
      // Buttons & Actions
      "add_button": "Toevoegen",
      "reset_button": "Resetten",
      "submit_button": "Formulier versturen",
      "sending": "Verzenden...",
      "autosave": "Opslaan...",
      
      // Messages
      "saved_at": "Opgeslagen om {{time}}",
      "submitting": "Verzenden...",
      "submit_success": "Formulier succesvol verzonden!",
      "submit_error": "Verzendingsfout: {{error}}",
      "confirm_reset": "Formulier wissen?",
      
      // Additional form options
      "option_other": "Anders",
      "option_none": "--",
      "current_url_label": "Huidige URL",
      "other_precision_label": "Andere specificatie",
      
      // Page volume options
      "pages_1_5": "1-5",
      "pages_5_15": "5-15",
      "pages_15_40": "15-40",
      "pages_40": "40+",
      "page_volume": "Pagina volume",
      
      // Content management options
      "cms_static": "Statisch",
      "cms_simple": "Eenvoudige CMS",
      "cms_custom": "Aangepast beheerpaneel",
      
      // Media options
      "media_images": "Afbeeldingen",
      "media_video": "Video",
      "media_documents": "Documenten",
      "media_none": "Geen",
      
      // Summary section
      "dynamic_summary": "Dynamisch Overzicht",
      "completion_label": "{{percent}}% Voltooid",
      "complexity_label": "Complexiteit",
      "complexity_basique": "Basis",
      "complexity_standard": "Standaard",
      "complexity_avancé": "Geavanceerd",
      "complexity_complexe": "Complex",
      "price_estimate": "Prijsschatting",
      "base_minimum": "Minimum basis",
      "includes_label": "Inclusief",
      "price_note": "Regionale indicatieprijs (Noord-Frankrijk) – definitieve offerte na overleg.",
      "identification_summary": "Identificatie",
      "type_summary": "Type",
      "objectives_summary": "Doelstellingen",
      "features_summary": "Functies",
      "framework_summary": "Framework",
      "priorities_summary": "Prioriteiten",
      "description_summary": "Beschrijving",
      "company_label": "Bedrijf",
      "contact_label": "Contact",
      "phone_label": "Tel",
      "budget_label": "Budget",
      "deadline_label": "Deadline",
      
      // Placeholders
      "add_feature_placeholder": "Functie toevoegen",
      "other_objective_placeholder": "Andere doelstelling",
      "target_countries_placeholder": "Frankrijk, Canada...",
      "inspiration_links_placeholder": "Inspiratie links (1 per regel)",
      "description_placeholder": "Beschrijf uw project, behoeften, gewenste functies, deadlines...",
      "description_help": "💡 Vermeld belangrijke functies, uw doelen, tijdsbeperkingen, geschat budget of andere nuttige informatie.",
      "https_placeholder": "https://...",
      
      // HowItWorks Component
      "how_title": "Hoe werkt het?",
      "how_subtitle": "Een duidelijk proces in 5 stappen om uw idee werkelijkheid te maken",
      "how_step1_title": "Gedetailleerd Formulier",
      "how_step1_desc": "U vult het formulier in met al uw projectdetails",
      "how_step1_duration": "10 min",
      "how_step2_title": "Aangepaste Offerte",
      "how_step2_desc": "We analyseren uw verzoek en sturen binnen 24u een offerte op maat",
      "how_step2_duration": "24u",
      "how_step3_title": "Design & Mockups",
      "how_step3_desc": "Ons team maakt visuele mockups ter validatie",
      "how_step3_duration": "3-5 dagen",
      "how_step4_title": "Ontwikkeling",
      "how_step4_desc": "We ontwikkelen uw oplossing met regelmatige updates",
      "how_step4_duration": "2-8 weken",
      "how_step5_title": "Oplevering & Lancering",
      "how_step5_desc": "Eindtests, live zetten en gebruikstraining",
      "how_step5_duration": "2-3 dagen",
      "how_cta_title": "Klaar om uw project te starten?",
      "how_cta_primary": "Formulier invullen",
      "how_cta_secondary": "Bel ons",
      
      // TrustBar Component
      "trust_secure_payment": "Veilige betaling",
      "trust_quick_quote": "Offerte in 24u",
      "trust_support": "30 dagen support",
      "trust_delivery": "Gegarandeerde levering",
      
      // FAQ Component
      "faq_title": "Veelgestelde Vragen",
      "faq_subtitle": "Alles wat u moet weten voordat u begint",
      "faq_q1": "Hoeveel kost een website?",
      "faq_a1": "De prijs varieert per complexiteit: €500-2000 voor een showcase site, €1000-6000 voor e-commerce, en meer voor aangepaste oplossingen. Elk project is uniek, daarom bieden we een persoonlijke offerte na analyse van uw verzoek.",
      "faq_q2": "Hoe lang duurt de ontwikkeling?",
      "faq_a2": "Een showcase site duurt meestal 2-4 weken, een e-commerce site 4-8 weken, en een complexe applicatie 2-6 maanden. Tijdlijnen hangen af van projectcomplexiteit en validatiesnelheid.",
      "faq_q3": "Kan ik mijn site wijzigen na oplevering?",
      "faq_a3": "Absoluut! We leveren alle projecten met een intuïtief beheerpaneel waarmee u eenvoudig content kunt wijzigen (tekst, afbeeldingen, producten). Voor technische wijzigingen bieden we onderhoudspakketten.",
      "faq_q4": "Bieden jullie hosting aan?",
      "faq_a4": "Ja! We bieden twee opties: een levenslang gratis hostingpakket (+€100 op initiële offerte) of een maandelijks abonnement voor €15. In beide gevallen beheren wij infrastructuur, beveiliging en backups.",
      "faq_q5": "Wordt mijn site geoptimaliseerd voor mobiel?",
      "faq_a5": "Al onze sites zijn 100% responsive, dus perfect aangepast aan smartphones, tablets en computers. We testen op alle apparaten voor oplevering.",
      "faq_q6": "Wat zit er in de prijs?",
      "faq_a6": "De prijs omvat: aangepast ontwerp, ontwikkeling, content integratie, basis SEO optimalisatie, gebruikstraining, 30 dagen support na lancering. Hosting en domeinnaam zijn extra.",
      "faq_q7": "Kan ik voorbeelden zien van uw werk?",
      "faq_a7": "Natuurlijk! Neem contact op per telefoon of email en we sturen u ons portfolio met vergelijkbare projecten. Omdat elk project vertrouwelijk is, kunnen sommige voorbeelden niet openbaar worden gedeeld.",
      "faq_q8": "Hoe werkt de betaling?",
      "faq_a8": "We werken meestal in 3 termijnen: 30% bij ondertekening offerte, 40% bij validatie mockups, en 30% bij eindoplevering. Andere regelingen zijn mogelijk op basis van uw situatie.",
      "faq_more_questions": "Heeft u meer vragen?",
      "faq_call_us": "Bel ons",
      "faq_send_brief": "Formulier invullen",
      
      // CTA Variations
      "cta_urgent_badge": "Beperkte aanbieding",
      "cta_urgent_title": "Start vandaag nog uw project!",
      "cta_urgent_subtitle": "Profiteer van onze speciale aanbieding voor de volgende 5 klanten",
      "cta_urgent_benefit1": "Gratis offerte binnen 24u",
      "cta_urgent_benefit2": "-15% op ontwikkeling",
      "cta_urgent_benefit3": "Prioritaire ondersteuning",
      "cta_urgent_button": "Profiteer nu",
      "cta_urgent_remaining": "Nog maar 2 plekken deze maand",
      
      "cta_trust_title": "Werk met een vertrouwd bureau",
      "cta_trust_subtitle": "Meer dan 50 tevreden klanten vertrouwen ons met hun digitale projecten",
      "cta_trust_guarantee1_title": "Tevredenheidsgarantie",
      "cta_trust_guarantee1_desc": "Onbeperkte revisies tot definitieve validatie",
      "cta_trust_guarantee2_title": "Veilige betaling",
      "cta_trust_guarantee2_desc": "Beschermde en gespreide transacties",
      "cta_trust_guarantee3_title": "Tijdige levering",
      "cta_trust_guarantee3_desc": "Of volledige terugbetaling",
      "cta_trust_card_title": "Sluit u aan bij onze tevreden klanten",
      "cta_trust_reviews": "23 beoordelingen",
      "cta_trust_button": "Start mijn project",
      "cta_trust_note": "Geen verplichting • Gratis offerte",
      
      "cta_comparison_title": "Voor / Na WebCaliskan",
      "cta_comparison_subtitle": "Zie het verschil dat we kunnen maken voor uw bedrijf",
      "cta_comparison_before_title": "Zonder professionele site",
      "cta_comparison_before1": "Beperkte geloofwaardigheid bij klanten",
      "cta_comparison_before2": "Afhankelijk van social media",
      "cta_comparison_before3": "Moeilijk uw diensten presenteren",
      "cta_comparison_before4": "Gemiste zakelijke kansen",
      "cta_comparison_after_title": "Met WebCaliskan",
      "cta_comparison_after1": "Professioneel en modern imago",
      "cta_comparison_after2": "24/7 zichtbaarheid op Google",
      "cta_comparison_after3": "Duidelijke presentatie van uw aanbod",
      "cta_comparison_after4": "Gekwalificeerde leadgeneratie",
      "cta_comparison_button": "Maak nu het verschil",
      
      "cta_simple_title": "Een vraag? Een project?",
      "cta_simple_subtitle": "Laten we uw idee bespreken onder het genot van een (virtuele) koffie ☕",
      "cta_simple_button1": "Formulier invullen",
      "cta_simple_button2": "📞 +33 6 49 87 62 36",
      
      // Theme Toggle
      "theme_toggle_aria": "Thema wisselen",
      "theme_switch_to_dark": "Schakel naar donkere modus",
      "theme_switch_to_light": "Schakel naar lichte modus",
      
      // Availability Widget
      "locale_code": "nl-NL",
      "availability_available": "Nu beschikbaar",
      "availability_available_message": "Ons team is online en klaar om te reageren",
      "availability_busy": "Tijdelijk bezet",
      "availability_busy_message": "We komen binnen enkele minuten bij u terug",
      "availability_offline": "Momenteel offline",
      "availability_offline_message": "We reageren zodra we terug zijn",
      "availability_next_slots": "Volgende beschikbare momenten",
      "availability_call_now": "Nu bellen",
      "availability_send_brief": "Formulier invullen",
      "availability_response_time": "Reactie gegarandeerd binnen 24u",
      
      // Hero Section
      "hero_rating": "4.9/5 - 23 klantbeoordelingen",
      "hero_clients": "+50 voltooide projecten",
      "hero_main_title": "Transformeer uw idee naar een ",
      "hero_title_highlight": "professionele website",
      "hero_description": "Webbureau gespecialiseerd in showcase sites, e-commerce en aangepaste applicaties. Persoonlijke offerte binnen 24u, gegarandeerde levering.",
      "hero_feature1": "Offerte in 24u",
      "hero_feature2": "Vanaf €500",
      "hero_feature3": "Gegarandeerde levering",
      "hero_cta_primary": "Start mijn project",
      "hero_cta_secondary": "+33 6 49 87 62 36",
      "hero_trust1": "Snelle reactie",
      "hero_trust2": "Tevreden klanten",
      "hero_trust3": "Gemiddelde beoordeling",
      "hero_scroll": "Ontdek onze diensten",
      
      // Services Section
      "services_title": "Onze Diensten",
      "services_subtitle": "Weboplossingen aangepast aan al uw behoeften",
      "service1_title": "Showcase Website",
      "service1_desc": "Professionele site om uw bedrijf en diensten te presenteren",
      "service1_feature1": "Aangepast ontwerp",
      "service1_feature2": "SEO optimalisatie",
      "service1_feature3": "Mobiel responsive",
      "service1_feature4": "Hosting inbegrepen",
      "service1_price": "Vanaf €500",
      "service2_title": "E-commerce",
      "service2_desc": "Complete online winkel om uw producten 24/7 te verkopen",
      "service2_feature1": "Veilige betaling",
      "service2_feature2": "Catalogusbeheer",
      "service2_feature3": "Bestelling tracking",
      "service2_feature4": "Ingebouwde analytics",
      "service2_price": "Vanaf €1000",
      "service_popular": "Populair",
      "service3_title": "Webapplicatie",
      "service3_desc": "Aangepaste oplossing om uw bedrijfsprocessen te automatiseren",
      "service3_feature1": "Schaalbare architectuur",
      "service3_feature2": "Aangepaste API",
      "service3_feature3": "Beheerpaneel",
      "service3_feature4": "Technische ondersteuning",
      "service3_price": "Op offerte",
      "service_cta": "Vraag een offerte",
      "services_footer_text": "Heeft u een specifiek project in gedachten?",
      "services_footer_cta": "Laten we praten"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;